import axios from 'axios';

const cancelTokens = {};

const getRundschreibenAdmin = () => {
  return parseInt(document.querySelector('.rundschreiben-admin')?.dataset?.id) || 0;
};

// Erstelle eine Funktion, die einen Axios-Request durchführt
const makeRequest = async (url, querySelector, cancelToken) => {
  // Loader hinzufügen
  autoLoaderV2(querySelector);

  // Deine Request-Logik hier
  return axios.get(url, {
    params: {
      ajax: 1,
      id: getRundschreibenAdmin(),
    },
    cancelToken: cancelToken.token,
  }).then(response => {
    window.executeInnerHTML(document.querySelector(querySelector), response.data);
  }).catch(error => {
    if (axios.isCancel(error)) {
      console.log('Request abort:', error.message);
    } else {
      console.error('Error: ', error.message);
    }
  }).finally(() => {
    // Loader entfernen
    autoLoaderV2(querySelector, true);
  });
};

// Erstelle eine Funktion zum Abbrechen und Neustarten des Requests
const cancelAndRetry = async (url, querySelector, tokenKey) => {
  // Überprüfe, ob bereits ein Token für den Schlüssel existiert
  if (cancelTokens[tokenKey]) {
    // Rufe die cancel-Funktion auf, um den vorherigen Request abzubrechen
    cancelTokens[tokenKey].cancel('Request abgebrochen');
  }

  // Erstelle ein neues CancelToken für den neuen Request
  cancelTokens[tokenKey] = axios.CancelToken.source();

  // Führe den Axios-Request mit dem neuen CancelToken durch
  await makeRequest(url, querySelector, cancelTokens[tokenKey]);
};

const refreshContentArea = () => {
  const rundschreibenContentArea = document.querySelector('.js--rundschreiben-ajax-content-area');
  if (rundschreibenContentArea) {
    // Loader anzeigen
    autoLoaderV2('.js--rundschreiben-ajax-content-area');

    cancelAndRetry(BASE_PATH + 'ajax/list/content-area', '.js--rundschreiben-ajax-content-area', 'content-area');
  }
};

const refreshEditBlockArea = () => {
  const rundschreibenEditBlockArea = document.querySelector('.js--rundschreiben-ajax-edit-content-area');
  if (rundschreibenEditBlockArea) {
    // Loader anzeigen
    autoLoaderV2('.js--rundschreiben-ajax-edit-content-area');

    cancelAndRetry(BASE_PATH + 'ajax/list/edit-block-area', '.js--rundschreiben-ajax-edit-content-area', 'edit-content-area');
  }
};

const refreshStatusArea = () => {
  const rundschreibenStatusArea = document.querySelector('.js--rundschreiben-ajax-status-area');
  if (rundschreibenStatusArea) {
    // Loader anzeigen
    autoLoaderV2('.js--rundschreiben-ajax-status-area');

    cancelAndRetry(BASE_PATH + 'ajax/list/status-area', '.js--rundschreiben-ajax-status-area', 'status-area');
  }
};

const addBlock = (type, position = 0) => {
  if (typeof type === 'undefined' || type === '') {
    return;
  }

  const mode = 'add';

  // POST request
  axios.post(BASE_PATH + 'ajax/helper/modifyRundschreibenAdminSession', window.object2FormData({
    mode,
    type,
    position,
    id: getRundschreibenAdmin(),
  })).then(function(response) {
  }).finally(() => {
    refreshContentArea();
    refreshEditBlockArea();
    refreshStatusArea();
  });
};

const removeBlock = (position = 0) => {
  const mode = 'remove';

  // POST request
  axios.post(BASE_PATH + 'ajax/helper/modifyRundschreibenAdminSession', window.object2FormData({
    mode,
    position,
    id: getRundschreibenAdmin(),
  })).then(function(response) {
  }).finally(() => {
    refreshContentArea();
    refreshEditBlockArea();
    refreshStatusArea();
  });
};

const moveBlock = (oldPosition = 0, position = 0) => {
  const mode = 'move';

  // POST request
  axios.post(BASE_PATH + 'ajax/helper/modifyRundschreibenAdminSession', window.object2FormData({
    mode,
    oldPosition,
    position,
    id: getRundschreibenAdmin(),
  })).then(function(response) {
  }).finally(() => {
    refreshContentArea();
    refreshEditBlockArea();
    refreshStatusArea();
  });
};

const startEditBlock = (position = 0) => {
  const mode = 'startEdit';

  // POST request
  axios.post(BASE_PATH + 'ajax/helper/modifyRundschreibenAdminSession', window.object2FormData({
    mode,
    position,
    id: getRundschreibenAdmin(),
  })).then(function(response) {
  }).finally(() => {
    refreshContentArea();
    refreshEditBlockArea();
  });
};

const editBlock = (data, position = 0) => {
  const mode = 'edit';

  // POST request
  axios.post(BASE_PATH + 'ajax/helper/modifyRundschreibenAdminSession', window.object2FormData({
    mode,
    position,
    data,
    id: getRundschreibenAdmin(),
  })).then(function(response) {
  }).finally(() => {
    refreshContentArea();
    refreshStatusArea();
  });
};

const endEditBlock = () => {
  const mode = 'endEdit';

  // POST request
  axios.post(BASE_PATH + 'ajax/helper/modifyRundschreibenAdminSession', window.object2FormData({
    mode,
    id: getRundschreibenAdmin(),
  })).then(function(response) {
  }).finally(() => {
    refreshContentArea();
    refreshEditBlockArea();
  });
};

const editBlockType = (type, position = 0) => {
  const mode = 'editType';

  // POST request
  axios.post(BASE_PATH + 'ajax/helper/modifyRundschreibenAdminSession', window.object2FormData({
    mode,
    position,
    type,
    id: getRundschreibenAdmin(),
  })).then(function(response) {
  }).finally(() => {
    refreshContentArea();
    refreshEditBlockArea();
  });
};

const removeFile = (position, name, fileID) => {
  const mode = 'removeFile';

  // POST request
  axios.post(BASE_PATH + 'ajax/helper/modifyRundschreibenAdminSession', window.object2FormData({
    mode,
    position,
    name,
    fileID,
    id: getRundschreibenAdmin(),
  })).then(function(response) {
  }).finally(() => {
    refreshContentArea();
    refreshEditBlockArea();
    refreshStatusArea();
  });
};
const removeHeroImage = () => {
  const mode = 'removeHeroImage';

  // POST request
  axios.post(BASE_PATH + 'ajax/helper/modifyRundschreibenAdminSession', window.object2FormData({
    mode,
    id: getRundschreibenAdmin(),
  })).then(function(response) {
  }).finally(() => {
    refreshContentArea();
    refreshStatusArea();
  });
};

export {addBlock, removeBlock, moveBlock, editBlock, startEditBlock, endEditBlock, editBlockType, refreshContentArea, refreshStatusArea, refreshEditBlockArea, removeFile, removeHeroImage, getRundschreibenAdmin};
